import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import ActionButton, {atomActionButtonColors, atomActionButtonStyles} from '@s-ui/react-atom-action-button'
import Context from '@s-ui/react-context'
import ExpandAlt from '@adv-mt/mt-svg-icons/lib/ExpandAlt'
import ShrinkAlt from '@adv-mt/mt-svg-icons/lib/ShrinkAlt'

import {FULL_SIZE_ACTION_BUTTON_CLASS, FULL_SIZE_BUTTON_POSITIONS} from '../config.js'

const GalleryBasicFullSizeActionButton = ({
  isFullSize,
  onClickFullSizeActionBtn,
  fullSizeButtonPosition = FULL_SIZE_BUTTON_POSITIONS.topRight,
  fullSizeExpandButtonClass = ''
}) => {
  const {i18n} = useContext(Context)

  const FullSizeIcon = isFullSize ? ShrinkAlt : ExpandAlt
  const fullSizeStyle = isFullSize ? atomActionButtonStyles.FILLED_POSITIVE : atomActionButtonStyles.FILLED_NEGATIVE

  const handleClickFullSizeActionBtn = () => onClickFullSizeActionBtn()

  const position = isFullSize ? FULL_SIZE_BUTTON_POSITIONS.topRight : FULL_SIZE_BUTTON_POSITIONS[fullSizeButtonPosition]
  const buttonClass = isFullSize ? '' : fullSizeExpandButtonClass
  const baseClass = cx(`${FULL_SIZE_ACTION_BUTTON_CLASS} ${FULL_SIZE_ACTION_BUTTON_CLASS}-${position} ${buttonClass}`)

  return (
    <ActionButton
      className={baseClass}
      color={atomActionButtonColors.PRIMARY}
      icon={<FullSizeIcon aria-hidden role="presentation" />}
      onClick={handleClickFullSizeActionBtn}
      style={fullSizeStyle}
      aria-label={isFullSize ? i18n.t('COMMON.HIDE') : i18n.t('COMMON.SHOW')}
    />
  )
}

GalleryBasicFullSizeActionButton.displayName = 'GalleryBasicFullSizeActionButton'
GalleryBasicFullSizeActionButton.propTypes = {
  isFullSize: PropTypes.bool,
  onClickFullSizeActionBtn: PropTypes.func,
  fullSizeButtonPosition: PropTypes.oneOf(Object.values(FULL_SIZE_BUTTON_POSITIONS)),
  fullSizeExpandButtonClass: PropTypes.string
}

export default GalleryBasicFullSizeActionButton
